import React from "react";
import { DashboardEditorProps } from "components/ComponentType";
import CommonChartEditor from "../../CommonChartEditor";
import { DatasetChartProps } from "../../interfaces";

function DatasetBarChartEditor({
  config,
  onConfigChange,
}: DashboardEditorProps<DatasetChartProps>) {
  return (
    <div>
      <CommonChartEditor config={config} onConfigChange={onConfigChange} />
    </div>
  );
}
export default DatasetBarChartEditor;
